module.exports = __webpack_public_path__ + "img/svg/matches-highlighted.2c09e08ca39ebe0465e982df1fe54b11.svg";